module.exports = __webpack_public_path__ + "static/img/loading-line-3.87d39b4.png";